import { StatusType } from "pages/Orders/SalaryCardOrder/constants/fieldValues.constant";

export enum SalaryCardActionTypes {
  FETCH_SALARY_CARD_REQUEST = 'FETCH_SALARY_CARD_REQUEST',
  FETCH_SALARY_CARD_SUCCESS = 'FETCH_SALARY_CARD_SUCCESS',
  FETCH_SALARY_CARD_FAILURE = 'FETCH_SALARY_CARD_FAILURE',

  FETCH_TRUSTED_PERSON_REQUEST = 'FETCH_TRUSTED_PERSON_REQUEST',
  FETCH_TRUSTED_PERSON_SUCCESS = 'FETCH_TRUSTED_PERSON_SUCCESS',
  FETCH_TRUSTED_PERSON_FAILURE = 'FETCH_TRUSTED_PERSON_FAILURE',
  
  FETCH_TRUSTED_PERSON_BY_PIN_SUCCESS = 'FETCH_TRUSTED_PERSON_BY_PIN_SUCCESS',
  FETCH_TRUSTED_PERSON_BY_PIN_FAILURE = 'FETCH_TRUSTED_PERSON_BY_PIN_FAILURE',
  FETCH_TRUSTED_PERSON_BY_PIN_REQUEST = 'FETCH_TRUSTED_PERSON_BY_PIN_REQUEST',

  FETCH_UPDATE_TRUSTED_PERSON_SUCCESS = 'FETCH_UPDATE_TRUSTED_PERSON_SUCCESS',
  FETCH_DELETE_TRUSTED_PERSON_SUCCESS = 'FETCH_DELETE_TRUSTED_PERSON_SUCCESS',

  FETCH_UPLOAD_SALARY_CARD_EXCEL_REQUEST = 'FETCH_UPLOAD_SALARY_CARD_EXCEL_REQUEST',
  FETCH_UPLOAD_SALARY_CARD_EXCEL_SUCCESS = 'FETCH_UPLOAD_SALARY_CARD_EXCEL_SUCCESS',
  FETCH_UPLOAD_SALARY_CARD_EXCEL_FAILURE = 'FETCH_UPLOAD_SALARY_CARD_EXCEL_FAILURE',
  FETCH_UPLOAD_SALARY_CARD_EXCEL_RESET = 'FETCH_UPLOAD_SALARY_CARD_EXCEL_RESET',

  SALARY_CARD_LIST_EXCEL = 'SALARY_CARD_LIST_EXCEL',
  FETCH_SALARY_CARD_DETAIL_INFO_REQUEST = 'FETCH_SALARY_CARD_DETAIL_INFO_REQUEST',
  FETCH_SALARY_CARD_DETAIL_INFO_SUCCESS = 'FETCH_SALARY_CARD_DETAIL_INFO_SUCCESS',
  FETCH_SALARY_CARD_DETAIL_INFO_FAILURE = 'FETCH_SALARY_CARD_DETAIL_INFO_FAILURE',

  SET_XRF_VALUE =  'SET_XRF_VALUE',

  FETCH_BUSSINESS_CARDS_REQUEST = 'FETCH_BUSSINESS_CARDS_REQUEST',
  FETCH_BUSSINESS_CARDS_SUCCESS = 'FETCH_BUSSINESS_CARDS_SUCCESS',
  FETCH_BUSSINESS_CARDS_FAILURE = 'FETCH_BUSSINESS_CARDS_FAILURE',

  FETCH_ORDER_NO_INFO_REQUEST = 'FETCH_ORDER_NO_INFO_REQUEST',
  FETCH_ORDER_NO_INFO_SUCCESS = 'FETCH_ORDER_NO_INFO_SUCCESS',
  FETCH_ORDER_NO_INFO_RESET = 'FETCH_ORDER_NO_INFO_RESET',
  FETCH_ORDER_NO_INFO_FAILURE = 'FETCH_ORDER_NO_INFO_FAILURE',

  FETCH_CREATE_SALARY_CARD_REQUEST = 'FETCH_CREATE_SALARY_CARD_REQUEST',
  FETCH_CREATE_SALARY_CARD_SUCCESS = 'FETCH_CREATE_SALARY_CARD_SUCCESS',
  FETCH_CREATE_SALARY_CARD_FAILURE = 'FETCH_CREATE_SALARY_CARD_FAILURE',

  FETCH_ORDERS_STATUS_LIST_REQUEST = 'FETCH_ORDERS_STATUS_LIST_REQUEST',
  FETCH_ORDERS_STATUS_LIST_SUCCESS = 'FETCH_ORDERS_STATUS_LIST_SUCCESS',
  FETCH_ORDERS_STATUS_LIST_FAILURE = 'FETCH_ORDERS_STATUS_LIST_FAILURE',

  FETCH_DELETED_ORDER_REQUEST = 'FETCH_DELETED_ORDER_REQUEST',
  FETCH_DELETED_ORDER_SUCCESS = 'FETCH_DELETED_ORDER_SUCCESS',
  FETCH_DELETED_ORDER_FAILURE = 'FETCH_DELETED_ORDER_FAILURE',
  RESET_DELETED_ORDER_STATUS = 'RESET_DELETED_ORDER_STATUS',
}

export enum CardCurrenyType {
  AZN = "AZN",
  USD = "USD",
  EUR = "EUR",
}

export enum CardType {
  VISA = "VISA",
  MASTERCARD = "MASTERCARD"
}

export enum OrderType {
  ORDINARY = "ORDINARY",
  URGENT = "URGENT",
}

export enum OrderDeliveryType {
  BANK = "BANK",
  COURIER = "COURIER"
}

export enum PasswordType {
  AA = "AA",
  AZE = "AZE"
}

export type TableListType = {
  customerInfo: string;
  serialType: PasswordType;
  serialNo: number;
  pin: string;
  position: string;
  salary: string | number;
  phoneNumber: string | number;
  code: string;
  email: string | '';
  pdfTransactionId?: string;
}

export type OrderSalaryCardType = {
  cardCurrency: CardCurrenyType;
  cardType: CardType;
  orderType: OrderType;
  orderDeliveryType: OrderDeliveryType;
  orderBranch: string;
  branchTransferred: string;
  note?: string;
  trustedPerson: TrustedPersonType;
  tableList: TableListType[]
};

export interface SalaryCardType {
  createdDate: string
  orderNo: string
  cardType: 'VISA' | 'MASTERCARD'
  cardCurrency: string
  orderType: string
  orderDeliveryType: string
  totalCount: number
  rejectedCount: number
  status: string
}
export interface BusinessCardTypeForOrders {
  createdDate: string
  orderNo: string
  cardType: 'VISA' | 'MASTERCARD'
  cardCurrency: string
  orderType: string
  orderDeliveryType: string
  totalCommission: number
  status: string
}

export interface SalaryCardListExcelType {
  key: React.Key
  id: number // ids
  customerInfo: string
  serialType: string
  serialNo: number
  pin: string
  position: string
  salary: number
  phoneNumber: string
  code: string
  email: string
  passwordPdf: string
  formStatus: 'valid' | 'invalid'
}

export type TrustedPersonType = {
  id?: number | null;
  fullName: string;
  pin: string;
  phone: string;
  expiryDate: string
}
export interface orderStatusListType {
  status: StatusType
  count: number
}
export interface DeletedOrderType {
  id: string
}

export interface BusinessCardType {
  cardName: string;
  paymentSystem: string;
}

export interface OrderNoInfo {
  branchNo: string | null;
  urgent: boolean;
  courier: boolean;
}

export interface SalaryCardState {
  salaryCardList: Array<SalaryCardType>
  salaryStatus: 'idle' | 'loading' | 'success' | 'failed'
  salaryError: null | any

  salaryCardListExcel?: Array<SalaryCardListExcelType>
  salaryCardListExcelStatus: 'idle' | 'loading' | 'success' | 'failed'
  salaryCardListExcelError: null | any

  trustedPersonList: TrustedPersonType[]
  trustedPerson: TrustedPersonType | null
  trustedStatus: 'idle' | 'loading' | 'success' | 'failed'
  trustedByPinStatus: 'idle' | 'loading' | 'success' | 'failed'

  detailInformationList: DetailInformationDataType
  detailInfoStatus: 'idle' | 'loading' | 'success' | 'failed'
  detailInfoError: null | any
  xrf: any

  businessCardList: BusinessCardType[]
  businessCardListStatus: 'idle' | 'loading' | 'success' | 'failed'
  businessCardListError: null | any

  orderNoInfo: OrderNoInfo
  orderNoInfoStatus: 'idle' | 'loading' | 'success' | 'failed'
  orderNoInfoError: null | any

  createSalaryCardStatus: 'idle' | 'loading' | 'success' | 'failed'
  createSalaryCardError: null | any
  orderStatusList: orderStatusListType[]
  orderStatusListStatus: 'idle' | 'loading' | 'success' | 'failed'
  orderStatusListError: null | any

  deletedOrder: DeletedOrderType[]
  deletedOrderStatus: 'idle' | 'loading' | 'success' | 'failed'
  deletedOrderError: null | any
}

export interface FetchSalaryCardRequestAction {
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_REQUEST
}
export interface FetchSalaryCardSuccessAction {
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_SUCCESS
  payload: SalaryCardType[]
}
export interface FetchSalaryCardFailureAction {
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_FAILURE
  payload: string
}

export interface FetchUploadSalaryCardExcelRequestAction {
  type: SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_REQUEST
}
export interface FetchUploadSalaryCardExcelResetAction {
  type: SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_RESET
}
export interface FetchUploadSalaryCardExcelSuccessAction {
  type: SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_SUCCESS
  payload: SalaryCardListExcelType[]
}
export interface FetchUploadSalaryCardExcelFailureAction {
  type: SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_FAILURE
  payload: string
}

//* Trusted Person
export interface FetchTrustedPersonRequestAction {
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_REQUEST
}
export interface FetchTrustedPersonSuccessAction {
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_SUCCESS
  payload: TrustedPersonType[]
}
export interface FetchAddTrustedPersonSuccessAction {
  type: SalaryCardActionTypes.FETCH_UPDATE_TRUSTED_PERSON_SUCCESS
  payload: TrustedPersonType
}
export interface FetchDeleteTrustedPersonSuccessAction {
  type: SalaryCardActionTypes.FETCH_DELETE_TRUSTED_PERSON_SUCCESS
  payload: { id: number }
}
export interface FetchTrustedPersonByPinRequestAction {
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_REQUEST
}
export interface FetchTrustedPersonByPinSuccessAction {
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_SUCCESS
  payload: TrustedPersonType
}
export interface FetchTrustedPersonByPinFailureAction {
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_FAILURE
  payload: string
}
export interface FetchTrustedPersonFailureAction {
  type: SalaryCardActionTypes.FETCH_TRUSTED_PERSON_FAILURE
  payload: string
}
//* Trusted Person

export interface FetchSalaryCardDetailInfoRequestAction {
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_REQUEST
}
export interface FetchSalaryCardDetailInfoSuccessAction {
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_SUCCESS
  payload: DetailInformationDataType
}
export interface FetchSalaryCardDetailInfoFailureAction {
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_FAILURE
  payload: string
}
export interface SetXrfValueAction {
  type: SalaryCardActionTypes.SET_XRF_VALUE
  payload: string
}
export interface FetchOrderStatusListRequestAction {
  type: SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_REQUEST
}
export interface FetchOrderStatusListSuccessAction {
  type: SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_SUCCESS
  payload: orderStatusListType[]
}

export interface FetchBusinessCardsRequestAction {
  type: SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_REQUEST
}
export interface FetchBusinessCardsSuccessAction {
  type: SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_SUCCESS
  payload: BusinessCardType[]
}
export interface FetchBusinessCardsFailureAction {
  type: SalaryCardActionTypes.FETCH_BUSSINESS_CARDS_FAILURE
  payload: string
}

export interface FetchOrderNoInfoRequestAction {
  type: SalaryCardActionTypes.FETCH_ORDER_NO_INFO_REQUEST
}
export interface FetchOrderNoInfosSuccessAction {
  type: SalaryCardActionTypes.FETCH_ORDER_NO_INFO_SUCCESS
  payload: OrderNoInfo
}
export interface FetchOrderNoInfosResetAction {
  type: SalaryCardActionTypes.FETCH_ORDER_NO_INFO_RESET
}
export interface FetchOrderNoInfoFailureAction {
  type: SalaryCardActionTypes.FETCH_ORDER_NO_INFO_FAILURE
  payload: string
}

export interface FetchCreateSalaryCardRequestAction {
  type: SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_REQUEST
}
export interface FetchCreateSalaryCardSuccessAction {
  type: SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_SUCCESS
}
export interface FetchCreateSalaryCardFailureAction {
  type: SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_FAILURE
  payload: string
}
export interface FetchOrderStatusListFailureAction {
  type: SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_FAILURE
  payload: string
}
// DELETE ORDER

export interface OrderDeletedRequestAction {
  type: SalaryCardActionTypes.FETCH_DELETED_ORDER_REQUEST
}
export interface OrderDeletedSuccessAction {
  type: SalaryCardActionTypes.FETCH_DELETED_ORDER_SUCCESS
  payload: DeletedOrderType
}

export interface OrderDeletedFailureAction {
  type: SalaryCardActionTypes.FETCH_DELETED_ORDER_FAILURE
  payload: string
}
export interface OrderDeletedStatusResest {
  type: SalaryCardActionTypes.RESET_DELETED_ORDER_STATUS
}
export type HistoryTableDataType = {
  rejectionReason?: string
  date: string | Date
  username: string
  previousStatus: string
  jobTransferred: string
  status: string
  newStatus: string
}
export interface DetailInfoMainTableType {
  key: React.Key
  id: number
  customerInfo: string
  serialType: string
  serialNo: number
  pin: string
  position: string
  salary: number
  phoneNumber: string
  code: string
  email: string
  passwordPdf: string
}
export interface OrderDetailInfoHeaderDataType {
  currency: string
  cardType: string
  branch: string
  deliveryMethod: string
  orderType: string
  branchToPickup: string
  allCount: string
  rejectCount: string
  FIN: string
  note: string
}
export interface  trustedPersonType {
  id:number,
  fullName:string,
  pin: string,
  phone:string
}
interface EmployeesType {
  id: number;
  email: string ;
  fullName: string ;
  phone: string;
  pin: string;
  position: string;
  salary: number;
  secretKey: string;
  serialNo: string;
  serialType: string;
  description: string;
  passwordPdfName: string;
  status: string;
}
export interface TableHistoryDataType {
  key: string
  actionDate: string
  operatorUsername: string
  previousStatus: string
  actionWithOrderStatus: string
  acquiredStatus: string
  comment?: string
}
export interface TableCommentDataType {
  date: string
  comment?: string
}
export type DetailInformationDataType = {
  trustedPerson: trustedPersonType
  employees: EmployeesType[]
}

export type SalaryCardActions =
  | FetchSalaryCardRequestAction
  | FetchSalaryCardSuccessAction
  | FetchSalaryCardFailureAction
  | FetchUploadSalaryCardExcelRequestAction
  | FetchUploadSalaryCardExcelFailureAction
  | FetchUploadSalaryCardExcelSuccessAction
  | FetchUploadSalaryCardExcelResetAction
  | FetchTrustedPersonFailureAction
  | FetchTrustedPersonSuccessAction
  | FetchTrustedPersonRequestAction
  | FetchAddTrustedPersonSuccessAction
  | FetchTrustedPersonByPinSuccessAction
  | FetchDeleteTrustedPersonSuccessAction
  | FetchSalaryCardDetailInfoRequestAction
  | FetchSalaryCardDetailInfoSuccessAction
  | FetchSalaryCardDetailInfoFailureAction
  | SetXrfValueAction
  | FetchBusinessCardsFailureAction
  | FetchBusinessCardsRequestAction
  | FetchBusinessCardsSuccessAction
  | FetchOrderNoInfoRequestAction
  | FetchOrderNoInfosSuccessAction
  | FetchOrderNoInfosResetAction
  | FetchOrderNoInfoFailureAction
  | FetchCreateSalaryCardRequestAction
  | FetchCreateSalaryCardSuccessAction
  | FetchCreateSalaryCardFailureAction
  | FetchOrderStatusListRequestAction
  | FetchOrderStatusListSuccessAction
  | FetchOrderStatusListFailureAction
  | OrderDeletedRequestAction
  | OrderDeletedSuccessAction
  | OrderDeletedFailureAction
  | OrderDeletedStatusResest
  | FetchTrustedPersonByPinFailureAction
  | FetchTrustedPersonByPinRequestAction